import { useEffect } from 'react'

const BASE = 'https://onceupona.stream'

function setMetaAttr(selector, attrKey, attrVal, content) {
  let el = document.querySelector(selector)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attrKey, attrVal)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

export function usePageMeta({ title, description, canonical, noindex = false, jsonLd = null }) {
  useEffect(() => {
    const origTitle = document.title

    if (title) {
      document.title = title
      setMetaAttr('meta[property="og:title"]',       'property', 'og:title',       title)
    }
    if (description) {
      setMetaAttr('meta[name="description"]',         'name',     'description',     description)
      setMetaAttr('meta[property="og:description"]',  'property', 'og:description',  description)
    }

    let canon = document.querySelector('link[rel="canonical"]')
    if (!canon) { canon = document.createElement('link'); canon.rel = 'canonical'; document.head.appendChild(canon) }
    canon.href = canonical || `${BASE}/`

    let robots = document.querySelector('meta[name="robots"]')
    if (noindex) {
      if (!robots) { robots = document.createElement('meta'); robots.setAttribute('name', 'robots'); document.head.appendChild(robots) }
      robots.setAttribute('content', 'noindex, nofollow')
    }

    let ld = null
    if (jsonLd) {
      ld = document.createElement('script')
      ld.type = 'application/ld+json'
      ld.textContent = JSON.stringify(jsonLd)
      document.head.appendChild(ld)
    }

    return () => {
      document.title = origTitle
      if (ld && ld.parentNode) ld.remove()
      const r = document.querySelector('meta[name="robots"]')
      if (r && noindex) r.remove()
    }
  }, [title, description, canonical, noindex, jsonLd])
}
